import * as THREE from "three";

/*
 * Warm ivory paper label with an understated "HCC" serif monogram and a thin
 * champagne-gold rule. Deliberately NO product name, vintage, ABV or tasting
 * notes — this is a corporate storytelling object.
 */
function draw(ctx, w, h) {
  // ivory paper base
  ctx.fillStyle = "#F7F1E7";
  ctx.fillRect(0, 0, w, h);

  // subtle paper grain
  for (let i = 0; i < 5200; i++) {
    const x = Math.random() * w;
    const y = Math.random() * h;
    ctx.fillStyle = Math.random() > 0.5 ? "rgba(60,45,30,0.028)" : "rgba(255,255,255,0.05)";
    ctx.fillRect(x, y, 1.6, 1.6);
  }

  // soft edge shading so the paper reads as wrapped around glass
  const edge = ctx.createLinearGradient(0, 0, w, 0);
  edge.addColorStop(0, "rgba(40,25,15,0.16)");
  edge.addColorStop(0.12, "rgba(40,25,15,0)");
  edge.addColorStop(0.88, "rgba(40,25,15,0)");
  edge.addColorStop(1, "rgba(40,25,15,0.16)");
  ctx.fillStyle = edge;
  ctx.fillRect(0, 0, w, h);

  // "HCC" monogram — embossed serif ink
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  const font = '500 224px "Cormorant Garamond", Georgia, "Times New Roman", serif';
  try {
    ctx.letterSpacing = "26px";
  } catch (e) {
    /* older canvas impls */
  }

  // emboss: light lift above, soft shadow below
  ctx.font = font;
  ctx.fillStyle = "rgba(255,255,255,0.75)";
  ctx.fillText("HCC", w / 2 + 12, h * 0.46 - 2.5);
  ctx.fillStyle = "rgba(30,18,10,0.28)";
  ctx.fillText("HCC", w / 2 + 12, h * 0.46 + 2.5);
  ctx.fillStyle = "#2b2018";
  ctx.fillText("HCC", w / 2 + 12, h * 0.46);

  // thin champagne-gold rule beneath the monogram
  const ruleW = w * 0.26;
  const ruleY = h * 0.665;
  ctx.fillStyle = "rgba(30,18,10,0.18)";
  ctx.fillRect(w / 2 - ruleW / 2, ruleY + 2.5, ruleW, 3);
  ctx.fillStyle = "#C7A45D";
  ctx.fillRect(w / 2 - ruleW / 2, ruleY, ruleW, 3);
}

export function createLabelTexture() {
  const w = 1024;
  const h = 640;
  const canvas = document.createElement("canvas");
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext("2d");
  draw(ctx, w, h);

  const texture = new THREE.CanvasTexture(canvas);
  texture.colorSpace = THREE.SRGBColorSpace;
  texture.anisotropy = 8;

  // redraw once webfonts are available so the monogram uses Cormorant Garamond
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => {
      draw(ctx, w, h);
      texture.needsUpdate = true;
    });
  }
  return texture;
}
